(function() {
	'use strict';

	angular.module('menuApp').controller('MenuController', MenuController);

	MenuController.$inject = [ '$window', '$timeout', '$cookies', 'MenuService',
			'$state', '$http', '$scope', 'GLOBAL_URL', '$base64', '$uibModal',
			'$stateParams', '$injector', 'Upload', 'authExpiredInterceptor', 'NgTableParams'];

	function MenuController($window, $timeout, $cookies, MenuService, $state,
			$http, $scope, GLOBAL_URL, $base64, $uibModal, $stateParams,
			$injector, Upload, authExpiredInterceptor, NgTableParams) {
		var vm = this;
		var self = $scope;
		
		vm.loadMenu = function() {
			MenuService.query({
				uri : 'loadMenu'
			}, function(result) {
				vm.listMenu = result;
			});
		}

		vm.loadAllMenu = function() {
			MenuService.query({
				uri : 'loadAllMenu'
			}, function(result) {
				vm.listMenu = result;
			});
		}
		
		vm.createNew = function() {
			$state.go('createNew');
		}
		
		vm.loadParentCategory = function() {
			MenuService.query({
				uri : 'loadParentCategory'
			}, function(result) {
				vm.listParentMenu = result;
				vm.loadDocumentEdit();
			});
		}
		
		vm.edit = false;
		
		vm.createMenu = function() {
				MenuService.post({
					uri : 'save'
				}, vm.menu, function(mess) {
					$state.go('menu');
				}, function() {
					$state.go('menu');
				});
		}
		var modalInstance = null;
		vm.deleteMenu = function(documentId) {
			modalInstance = $uibModal.open({
				animation : true,
				templateUrl : GLOBAL_URL
						+ 'partial?uri=menu/layout/deleteMenu',
				controller : 'MenuDialogController',
				controllerAs : 'vm',
				size : 'sm',
				resolve : {
					categoryId : function() {
						return documentId;// tranfer data for dialog
					}
				}
			});
			modalInstance.result.then(function(listCategory) {
				vm.loadMenu();
				modalInstance = null;
			}, function() {
			});
		}
		
		vm.updateMenu = function(menuID) {
			var uri = null;
    		var number = null;
    		if (menuID) {
    			uri = 'ga/menu/#/createMenu/';
    			number = $base64.encode(menuID);
    		}
    		uri = uri.concat(number);
    		$window.open(GLOBAL_URL + uri, '_self')
		}
		
		vm.loadDocumentEdit = function() {
			if ($stateParams.menuId !== undefined
					&& $stateParams.menuId !== null) {
				var menuId = $base64.decode($stateParams.menuId);
				if (menuId != null) {
					MenuService.get({
						uri : 'loadMenuEdit',
						menuId : menuId
					}, function(result) {
						vm.menu = result;
						if(vm.menu.parentMenu == null) {
							vm.edit = true;
						}
					});
				}
			}
		}
		
		self.oneAtATime = true;

		$scope.status = {
			    isCustomHeaderOpen: false,
			    isFirstOpen: true,
			    isFirstDisabled: false
			  };	
		
	}
})();
